"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBillingHistory = void 0;
const Leaf = __importStar(require("leaf-ts"));
const web_1 = require("@branch-ts/web");
const presentMechanism_1 = require("@branch-ts/web-consensus/src/presentMechanism");
const userBillingHistory_html_R_1 = require("./userBillingHistory.html.R");
const userBillingHistory_html_R_2 = require("./userBillingHistory.theme/business/userBillingHistory.html.R");
const userBillingHistory_html_R_3 = require("./userBillingHistory.theme/genesis/userBillingHistory.html.R");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
class UserBillingHistory extends userBillingHistory_html_R_1.R.UserBillingHistory {
    constructor() {
        super();
        this.fault = (0, web_1.FatUIErrorBestPractice)();
        this.stages = new web_1.StagesBehavior(this).defines({
            state: "empty",
        });
        this.presentContext = presentMechanism_1.PresentMechanism.ensure(this)
            .lifeCycle(async (declares) => {
            await declares.declare("present");
            await this.refresh();
            await declares.declare("hang");
        });
        versetUserProfileMechanism_1.VersetUserProfileMechanism.events.of.refresh.listenBy(this, () => {
            void this.refresh();
        });
    }
    async refresh() {
        const server = versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
        const [historyResult, historyReason, ...historyErrors] = await server.rpcs.VersetUserBillingService.listMyInvoiceHistory({
            count: 50,
        });
        this.fault.caution.worry({
            message: "Failed to get billing history",
            reason: historyReason,
            errors: historyErrors,
        });
        const items = [...(historyResult?.items || [])]
            .sort((a, b) => b.at - a.at);
        this.historyItems.empty();
        if (items.length === 0) {
            this.stages.set("state", "empty");
            return;
        }
        this.stages.set("state", "ready");
        for (const item of items) {
            this.historyItems.push(new BillingHistoryItem(item));
        }
    }
    onClickManageSubscription(e) {
        e?.stopPropagation();
        e?.preventDefault();
        window.location.href = "/dashboard/profile?section=subscription";
    }
    onClickRefreshHistory(e) {
        e?.stopPropagation();
        e?.preventDefault();
        void this.refresh();
    }
}
exports.UserBillingHistory = UserBillingHistory;
class BillingHistoryItem extends userBillingHistory_html_R_1.R.UserBillingHistory.BillingHistoryItem {
    constructor(item) {
        super();
        const amount = this.formatAmount({
            exactAmount: item.exactAmount,
            amount: item.amount,
            currency: item.currency,
        });
        const tax = this.formatAmount({
            exactAmount: item.exactTaxAmount,
            amountMinor: item.taxAmountMinor,
            currency: item.currency,
        });
        const total = this.formatAmount({
            exactAmount: item.exactTotalAmount,
            amountMinor: item.totalAmountMinor,
            currency: item.currency,
        });
        this.VM.kind = item.state
            ? `${item.kind} · ${this.describeState(item.state)}`
            : item.kind;
        this.VM.amount = total || amount;
        this.VM.taxDetail = total && tax
            ? `${amount} before tax · ${tax} tax`
            : "";
        this.VM.createdAt = new Date(item.at).toLocaleString();
        this.VM.note = this.describeItem(item);
    }
    describeState(state) {
        return {
            awaitingPayment: "awaiting payment",
            paid: "paid",
            cancelled: "cancelled",
            expired: "expired",
        }[state];
    }
    describeItem(item) {
        if (item.kind === "additional usage") {
            return item.state === "paid"
                ? "Additional Verset AI usage is ready to use."
                : item.state === "awaitingPayment"
                    ? "Complete checkout to add additional usage."
                    : item.state === "cancelled"
                        ? "This checkout was cancelled."
                        : item.state === "expired"
                            ? "This checkout expired."
                            : "Additional Verset AI usage";
        }
        return item.label || "Billing activity";
    }
    formatAmount(option) {
        const exactAmount = option.exactAmount
            || (option.amountMinor != null ? this.exactAmountFromMinor({ amountMinor: option.amountMinor }) : undefined)
            || (option.amount != null ? `${option.amount}` : undefined);
        if (!exactAmount) {
            return "";
        }
        return option.currency ? `${exactAmount} ${option.currency.toUpperCase()}` : exactAmount;
    }
    exactAmountFromMinor(option) {
        if (!Number.isSafeInteger(option.amountMinor) || option.amountMinor < 0) {
            return undefined;
        }
        return `${Math.floor(option.amountMinor / 100)}.${String(option.amountMinor % 100).padStart(2, "0")}`;
    }
}
Leaf.WidgetThemeCenter.about(userBillingHistory_html_R_1.R.UserBillingHistory).add("business", userBillingHistory_html_R_2.R.UserBillingHistory.generator);
Leaf.WidgetThemeCenter.about(userBillingHistory_html_R_1.R.UserBillingHistory).add("genesis", userBillingHistory_html_R_3.R.UserBillingHistory.generator);
